export { default as PercentOutlineIcon } from './PercentOutlineIcon';
